<template>
  <ValidationObserver
    ref="dialogObserver"
    v-slot="{ valid }"
    slim="slim"
  >
    <AppDialog
      class="overtime-policy-dialog"
      title="Overtime policy members"
      append-to-body="append-to-body"
      show="show"
      @close="closeDialog"
    >
      <form
        id="overtime-policy-form"
        autocomplete="off"
        @submit.prevent="onFormSubmit"
      >
        <div class="form-group policy-alert edit-alert">
          <i class="hi hi-info-filled mr-10" />
          <span> Changes to the policy will take effect at the start of the organization's next week. </span>
        </div>

        <ValidationObserver
          ref="membersSelect"
          vid="memberObs"
          slim="slim"
        >
          <OvertimePoliciesMembersSelect
            :all-active-policies="allActivePolicies"
            :form="form"
            :members="members"
            :overtime-policy="overtimePolicy"
            :overtime-policies="overtimePolicies"
            new-member-warning
            :disabled="disabled"
            @open-pay-dialog="openPayDialog"
          />
        </ValidationObserver>
      </form>

      <template #footer>
        <div
          v-if="fieldError('overtime_policy')"
          class="has-error m-0"
        >
          <div class="help-block d-flex align-items-center justify-content-end">
            <i class="hi hi-info-filled mr-5" />
            Overtime policy {{ fieldError('overtime_policy') }}
          </div>
        </div>

        <AppButton
          type="default"
          @click="closeDialog"
        >
          Cancel
        </AppButton>

        <button
          class="btn btn-primary"
          type="submit"
          form="overtime-policy-form"
          :disabled="!valid || disabled || form.processing"
        >
          Save
        </button>
      </template>
    </AppDialog>
  </ValidationObserver>
</template>
<script>
import { mapInertiaProps } from '~/utils/inertia';
import OvertimePoliciesMembersSelect from './OvertimePoliciesMembersSelect.vue';
import { applyTemplate } from '~/utils/url_template';

export default {
  name: 'OvertimePoliciesMembersDialog',
  components: {
    OvertimePoliciesMembersSelect,
  },
  props: {
    allActivePolicies: {
      type: Array,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    members: {
      type: Array,
      required: true,
    },
    overtimePolicy: {
      type: Object,
      default: () => ({}),
    },
    overtimePolicies: {
      type: Array,
      default: () => [],
    },
    overtimePoliciesUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showBillRateField: false,
      form: this.$inertia.form({
        user_organization_ids: this.overtimePolicy.user_organization_ids,
      }),
    };
  },
  computed: {
    ...mapInertiaProps({
      organization: 'organization',
    }),
    disabled() {
      return this.overtimePolicy.id && !this.overtimePolicy.can_edit;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    fieldError(field) {
      if (this.form.errors && this.form.errors[field]) {
        return this.form.errors[field][0];
      }
    },
    onFormSubmit() {
      const { origin } = window.location;
      const overtimePoliciesUrl = this.overtimePoliciesUrl;
      const overtimePoliciesUrlString = new URL(
        applyTemplate(overtimePoliciesUrl, {
          organizationId: this.organization.id,
          overtimePolicyId: this.overtimePolicy.id,
        }),
        origin,
      ).toString();

      this.form.transform((data) => {
        const payload = {};

        payload.user_organization_ids = data.user_organization_ids;

        return { overtime_policy: payload, organization_id: this.organization.id };
      });

      const options = { onSuccess: () => this.closeDialog() };

      return this.form.put(overtimePoliciesUrlString, options);
    },
    openPayDialog(member) {
      this.$emit('open-pay-dialog', member);
    },
  },
};
</script>
